"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("app");
document.querySelectorAll('.go-to-store .cta').forEach(ctaElement => {
    ctaElement.addEventListener('click', (ev) => {
        var _a;
        const cta = ev.currentTarget;
        const name = ((_a = cta.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '';
        const url = cta.getAttribute('href') || '';
        const target = cta.getAttribute('target');
        if (target === '_blank') {
            app_1.GTM.PMPButton(name, url);
        }
        else {
            ev.preventDefault();
            app_1.GTM.PMPButton(name, url, true);
        }
    });
});
